import React from "react";
import { number, bool, string } from "prop-types";

import "./author.m.css";

const AuthorName = ({
  key,
  name,
  lastIndex,
  secondLastIndex
}) => {
  const separator = lastIndex ? "" : secondLastIndex ? " ও" : ","

  return (
    <div
    styleName="blank-story-author"
    key={key}
    >
      {name + separator}
    </div>
  );
};

AuthorName.propTypes = {
  name: string,
  key: number,
  lastIndex: bool,
  secondLastIndex: bool
};

export default AuthorName;
